import { AppVersion } from "data/terra/AppVersion";
import Terra from 'services/apis/terra/Terra';
import { showLoading, showSuccess } from 'store/popup/actions';
import { TerraPaymentConfigMapperRequest } from "data/terra/TerraPaymentConfigMapper";
import { ThunkAction } from "redux-thunk";
import { RootState } from "store/reducer";
import { Action } from "redux";
import { t } from "helpers/i18n";
import { showErrorNotification } from "store/notification/actions";
import { NotificationPlacement } from "store/notification/util";
import { error } from "util/result";
import { commonConstants } from 'constants/index';

const { MODULE_NEED_CONFIG_MAPPER } = commonConstants

export const getPaymentConfig = () => {
    try {
        return JSON.parse(window.REACT_APP_TERRA_PAYMENT_CONFIG_IDS);
    } catch (error) {
        console.log(`Parse REACT_APP_TERRA_PAYMENT_CONFIG_IDS error: ${error}`);
        console.log(`REACT_APP_TERRA_PAYMENT_CONFIG_IDS: ${window.REACT_APP_PAYMENT_BFF_URL_CONFIGS}`);
        return null;
    }
}

export const syncTerraPaymentIfNeeded = (
    version: AppVersion
): ThunkAction<void, RootState, unknown, Action<any>> => async (
    dispatch,
    getState
) => {
        const selectedApp = getState().appSelector.selectedApp;
        const dispatchShowErrorNotification = (modules: string[]) => {
            dispatch(showErrorNotification({
                description: t('error_sync_terra_payment_message', {
                    modules: modules
                }),
                duration: 0,
                placement: NotificationPlacement.top
            }));
        }
        if (selectedApp) {
            const clientCode = `${selectedApp.product.code}:${selectedApp.platform.code}:${selectedApp.market.code}:${version.code}`;
            const paymentConfig = getPaymentConfig();
            if (paymentConfig) {
                dispatch(showLoading());
                const hestiaAppsResult = await Terra.frontEnd.fetchHestiaApps(clientCode);
                const configModules: string[] = [];
                const results: string[] = [];
                if (hestiaAppsResult.isSuccess()) {
                    const promises: Promise<string | null>[] = [];
                    dispatch(showLoading());
                    hestiaAppsResult.get()?.data.forEach((module) => {
                        if (MODULE_NEED_CONFIG_MAPPER.includes(module.productCode)) {
                            configModules.push(module.productCode);
                            promises.push(
                                new Promise((resolve, reject) => {
                                    Terra.terraPayment.postConfigMapper(
                                        new TerraPaymentConfigMapperRequest(
                                            paymentConfig[module.productCode],
                                            module.moduleConfigId
                                        )
                                    )
                                        .then(result => {
                                            if (result.isSuccess()) {
                                                results.push(module.productCode)
                                            }
                                            resolve(null);
                                        })
                                        .catch(_ => { reject(); })
                                }
                                ))
                        }
                    });

                    if (promises.length == 0) {
                        dispatch(showSuccess());
                        return;
                    }
                    await Promise.all(promises)

                    if (results.length == configModules.length) {
                        dispatch(showSuccess());
                    } else {
                        const failModules = configModules.filter(it => !results.includes(it));
                        dispatchShowErrorNotification(failModules);
                    }
                } else {
                    if (MODULE_NEED_CONFIG_MAPPER.length > 0) {
                        dispatchShowErrorNotification(MODULE_NEED_CONFIG_MAPPER);
                    }
                }
            } else {
                if (MODULE_NEED_CONFIG_MAPPER.length > 0) {
                    dispatchShowErrorNotification(MODULE_NEED_CONFIG_MAPPER);
                }
            }
        } else {
            return error(new Error(t('Please select app first')));
        }
    }